import React, { Component } from "react";
import { storageKeys } from "config/settings.json";

import SubApp from 'components/SubApp';
import StorageHandler from 'config/StorageHandler';

export default class SubAppView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			appId: -1,
			chapterId: -1,
			email: "",
		};
	}

	UNSAFE_componentWillMount() {
		StorageHandler.load(storageKeys.activeSubApp).then((subApp) => {
			if (subApp && subApp.global) {
				const { appId, chapterId, email, pageId, type } = subApp.global;
				this.setState({
					appId,
					chapterId,
					email,
					pageId,
					type,
				});
			}
		});
	}

	componentWillUnmount() {
		document.body.classList.remove("no-scroll");
		document.body.classList.remove("subApp");
	}

	render() {
		const { appId, chapterId, email, pageId, type } = this.state;

		return (
			<div>
				{appId > 0 && (
					<SubApp
						appId={+appId}
						email={email}
						chapterId={chapterId}
						pageId={pageId}
						type={type}
					/>
				)}
			</div>
		);
	}
}
